export const PATH_TEST_PRICE_CREATE = "/app/products/tests/new";
export const PATH_TEST_OFFER_CREATE = "/app/offers/new";
export const PATH_TEST_PRICE = "/app/products/tests";
export const PATH_OFFER = "/app/offers";
export const PATH_SPONSORED_ADS = "/app/sponsoredAds";
export const PATH_AGENDA = "/app/agenda";
export const PATH_DASHBOARD = "/app/dashboard";
export const PATH_WELCOME_PAGE = "/app/welcome";
export const PATH_PRODUCT = "/app/products";
export const PATH_BENCHMARK = "/app/benchmark";
export const PATH_POS_PARAMETER = "/app/poss/parameter";
export const PATH_POS_LIST = "/app/pos-list";
export const PATH_SUPERADMIN = "/app/superadmin";
export const PATH_SUPERADMIN_MONITORING = "/app/superadmin-monitoring";
export const PATH_SUPERADMIN_ANALYZE = "/app/superadmin-analyze";
export const PATH_SUPERADMIN_ANALYZE_DASHBOARD = `${PATH_SUPERADMIN_ANALYZE}/dashboard`;
export const PATH_SUPERADMIN_DEBUG = "/app/superadmin-slot-debug";
export const PATH_SUPERADMIN_SUPERPOWER = "/app/superadmin-superpower";
export const PATH_HOME: string = PATH_DASHBOARD;
export const PATH_MANAGEMENT = "/app/offers";
export const PATH_POS_ONBOARDING = "/app/pos-onboarding";
export const PATH_MARKETING_ACTION = "/app/marketing-action";
export const PATH_ACCOUNT = "/app/account";
export const PATH_USER_PREFERENCES = "/app/account/preferences";
